import { useEffect, useState } from 'react';
import { useLazyGetAllClubQuery } from '../redux';

/** El controller de clubes topa `limit` en 100, así que el listado entero va por páginas. */
const POR_PAGINA = 100;

/**
 * Todos los clubes inscritos en un campamento, no la página que se ve en la tabla.
 *
 * Lo que se imprime —etiquetas QR, listado de inscritos— es siempre el campamento
 * entero o una zona completa. Imprimir "lo que cabía en pantalla" sería una trampa
 * silenciosa, y por eso esto pagina en bucle en vez de aceptar el `limit` de la vista.
 *
 * Carga bajo demanda (`enabled`): son hasta dos vueltas a la API que no hacen falta
 * hasta que alguien abre el diálogo.
 */
export function useAllClubs(enabled, campId) {
  const [traerClubes] = useLazyGetAllClubQuery();
  const [clubs, setClubs] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!enabled || !campId) return undefined;

    let cancelado = false;
    const cargar = async () => {
      setCargando(true);
      setError('');
      try {
        const acumulado = [];
        let pagina = 1;
        let total = Infinity;
        while (acumulado.length < total) {
          const res = await traerClubes({ campId, page: pagina, limit: POR_PAGINA }, true).unwrap();
          const results = res?.results ?? [];
          total = res?.pagination?.total ?? results.length;
          acumulado.push(...results);
          if (results.length === 0) break;
          pagina += 1;
        }
        if (!cancelado) setClubs(acumulado);
      } catch {
        if (!cancelado) setError('No se pudo cargar el listado de clubes.');
      } finally {
        if (!cancelado) setCargando(false);
      }
    };

    cargar();
    return () => {
      cancelado = true;
    };
  }, [enabled, campId, traerClubes]);

  return { clubs, cargando, error };
}
